import Vue from 'vue'
import Store from 'store'

import ProductInfoTablist from './ProductInfoTablist.vue'

const el = '.nti-component--product-info-tablist'
const DOM = document.querySelector(el)

const prepareData = function(){

    let data = {
        "tabData" : []
    }

    if(DOM){
        const dataDOM = DOM.querySelectorAll('.nti-js--product-info-data')
        dataDOM.forEach((dataPoint, index) => {
            data.tabData.push({
                label: dataPoint.dataset.label,
                id: index,
                content: dataPoint.dataset.content
            })
        })
    }
    return data
}

const render = function(){
    if(DOM){
        const compData = prepareData()
        new Vue({
            store: Store,
            el,
            data: {
                compData
            },
            components:{
                ProductInfoTablist
            },
            template: '<ProductInfoTablist/>'
        })
    }
}

export default {
    render
}